import React from 'react';
import PropTypes from 'prop-types';
import { Provider, connect } from 'react-redux';
import { Router, Route } from 'react-router-dom';
import { LoadSpinner } from 'cstar-react-primitives/lib/redux-form';
import { Helmet } from 'react-helmet';

import { getIntlIsLoading, getIntlLocale, getIntlCurrencyCode } from '../intl/intlSelectors';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import PromoBanner from '../promoDisplay/PromoBanner';
import NotificationPortal from '../notifications/NotificationPortal';
import ScrollToTopWrap from '../primitive/ScrollToTopWrap';
import { getDisplayBannerPaths } from '../routing/flowSelectors';
import { flowFactory } from '../routing/FlowRoute';
import ProgramIntlProvider from '../program/ProgramIntlProvider';
import { ConnectedCookieConsentBanner } from '../consent/CookieConsentBanner';
import { ConnectedTestEnvironmentBanner } from '../testEnvironment/TestEnvironmentBanner';

import { getEnv } from './bootstrap';
import appStore from './appStore';


const Flow = flowFactory(appStore.getState());


export const App = (props) => {
    const {
        loading,
        locale,
        currency,
        displayBannerPaths
    } = props;
    const showTestEnv = getEnv() !== 'PROD';

    return (
        <div className="app" key={`${locale}-${currency}`}>
            <Helmet>
                {}
                <html lang={locale} />
            </Helmet>
            <ConnectedCookieConsentBanner />
            {}

            { showTestEnv && (
                <ConnectedTestEnvironmentBanner />
            )}

            <Header {...props} />

            {}
            <Route path={displayBannerPaths} component={PromoBanner} />

            {}
            <main className="app-wrapper">
                {loading && <LoadSpinner overlay />}
                <Flow {...props} />
            </main>

            {}
            <Footer {...props} />

            <NotificationPortal {...props} />
        </div>
    );
};

App.defaultProps = {
    loading: false,
    currency: null
};

App.propTypes = {
    loading: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string,
    displayBannerPaths: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    loading: getIntlIsLoading(state),
    locale: getIntlLocale(state), 
    currency: getIntlCurrencyCode(state), 
    displayBannerPaths: getDisplayBannerPaths(state)
});

export const ConnectedApp = connect(mapStateToProps)(App);


const ReduxApp = ({ history }) => (
    <Provider store={appStore}>
        <ProgramIntlProvider>
            <Router history={history}>
                {}
                <ScrollToTopWrap>
                    <Route component={ConnectedApp} />
                </ScrollToTopWrap>
            </Router>
        </ProgramIntlProvider>
    </Provider>
);

ReduxApp.propTypes = {
    history: PropTypes.object.isRequired
};

export default ReduxApp;
